export default "__VITE_ASSET__CaT1ZNjk__"